import { FETCH_QUEUE_JOBS } from './constants';
import Http from '../http';

const fetchJobs = payload => ({
  type: FETCH_QUEUE_JOBS,
  payload,
});


export const getJobsStatus = (queueName, jobName, data) => dispatch =>
  Http.post(`/jobs/${queueName}/${jobName}/status`, data)
    .then(response => dispatch(fetchJobs(response)));


export const addJobToQueue = (queueName, jobName, data) => dispatch =>
  Http.post(`/jobs/${queueName}/${jobName}`, data)
    .then(() => dispatch(getJobsStatus(queueName, jobName, data)));
